import { render, staticRenderFns } from "./code-redeem-landing.vue?vue&type=template&id=de8a45fa&"
import script from "./code-redeem-landing.vue?vue&type=script&lang=js&"
export * from "./code-redeem-landing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports